var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "search-filters" }, [
    _c("div", { staticClass: "search-and-categories d-flex align-items-end" }, [
      _c(
        "div",
        { staticClass: "search-input-container" },
        [
          _c(_setup.CInput, {
            attrs: {
              label: "Search effects",
              placeholder: "Type to search...",
            },
            on: { input: _setup.handleSearchInput },
            scopedSlots: _vm._u([
              {
                key: "append",
                fn: function () {
                  return [
                    _setup.hasActiveFilters
                      ? _c(_setup.CButton, {
                          attrs: {
                            text: "Clear filters",
                            variant: "secondary",
                            size: "sm",
                          },
                          on: { click: _setup.handleClearFilters },
                        })
                      : _vm._e(),
                  ]
                },
                proxy: true,
              },
            ]),
            model: {
              value: _setup.searchInputRef,
              callback: function ($$v) {
                _setup.searchInputRef = $$v
              },
              expression: "searchInputRef",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "category-select" }, [
        _c(
          "select",
          {
            staticClass: "category-dropdown",
            domProps: { value: _setup.selectedCategoryValue },
            on: { change: _setup.handleCategorySelectChange },
          },
          _vm._l(_setup.categoryOptions, function (option) {
            return _c(
              "option",
              { key: option.value, domProps: { value: option.value } },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(option.label) +
                    "\n                "
                ),
              ]
            )
          }),
          0
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }